import type { QueryClient, QueryKey } from '@tanstack/react-query';

/** An imperative API action owns all the cached resources its successful write changes. */
export function actionOptions<Args extends unknown[], Result>(
  qc: QueryClient,
  action: (...args: Args) => Promise<Result>,
  invalidates: readonly QueryKey[],
) {
  return {
    mutationFn: (args: Args) => action(...args),
    onSuccess: () => Promise.all(invalidates.map((queryKey) => qc.invalidateQueries({ queryKey }))),
  };
}
